import type { DecisionEngineDestinationUI } from "./definition";

export const ajoUI: DecisionEngineDestinationUI = {
  campaignSetup: "event-triggered",
  resourceName: "campaign",
  channelDescription: "Adobe Journey Optimizer",
  getReferenceString: (s) => {
    const withoutPrefix = s.slice("hightouch.recommendation.".length);
    return `{{{context.${withoutPrefix}}}}`;
  },
  isPreviewSupported: true,
  getResourceType: () => "campaign",
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: true,
  showAssociatedTemplate: false,
};
